import React from 'react';
import ReactDOM from 'react-dom';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux'
import thunk from 'redux-thunk';

import fmReducer from './fm/reducers';
import {screenResize} from './fm/reducers/screen'
import {fetchLocation, release} from './fm/reducers/page'
import {doAuthentication, logout} from './fm/reducers/auth'
import Layout from './Layout';
import ThemeProvider from './fm/ThemeProvider'
import {addLocationListener, push} from './fm/lib/history'
import {LANGUAGES} from './config'
import {scrollToTopIfNeeded} from './fm/lib/ScrollObserver'

const store = createStore(
  	fmReducer,
  	applyMiddleware(thunk),
)
window.addEventListener('resize', () => store.dispatch(screenResize()))
const handleLocationChange = location => {
	const oldLocation = store.getState().page.location
	if(location === '/' && LANGUAGES && LANGUAGES.length>0) return push('/' + LANGUAGES[0])
	if(location === '/logout') store.dispatch(logout())
	if(location !== '/login') store.dispatch(fetchLocation(location))
	setTimeout(() => {
                scrollToTopIfNeeded()
                if(location!==oldLocation) store.dispatch(release(oldLocation))
                }, 500)
}
addLocationListener(handleLocationChange)
setTimeout(() => {
	store.dispatch(doAuthentication())
	handleLocationChange(window.location.pathname)
})

ReactDOM.render(
	<Provider store={store}>
	  <ThemeProvider>
	    <Layout/>
	  </ThemeProvider>
    </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js